import {
  EXTRA_PROFESSIONAL_PRICE_COP,
  INCLUDED_PROFESSIONALS,
  PROFESSIONAL_PLAN_PRICE_COP,
} from '@/content/pricing';

export const MERCADO_PAGO_PLAN_CODE = 'PROFESIONAL' as const;
export const FREE_PLAN_CODE = 'GRATIS' as const;

export type RegistrationPlanCode =
  | typeof FREE_PLAN_CODE
  | typeof MERCADO_PAGO_PLAN_CODE;

export const MONTHLY_BILLING_PRICES = Object.freeze({
  basePriceCop: PROFESSIONAL_PLAN_PRICE_COP,
  extraProfessionalPriceCop: EXTRA_PROFESSIONAL_PRICE_COP,
  includedProfessionals: INCLUDED_PROFESSIONALS,
});

export function normalizeProfessionalCount(value: number): number {
  if (!Number.isFinite(value)) return INCLUDED_PROFESSIONALS;
  return Math.max(INCLUDED_PROFESSIONALS, Math.trunc(value));
}

export function getExtraProfessionalCount(professionalCount: number): number {
  return Math.max(
    0,
    normalizeProfessionalCount(professionalCount) - INCLUDED_PROFESSIONALS
  );
}

export function calculateProfessionalPlanMonthlyTotal(
  professionalCount: number
): number {
  return (
    PROFESSIONAL_PLAN_PRICE_COP +
    getExtraProfessionalCount(professionalCount) * EXTRA_PROFESSIONAL_PRICE_COP
  );
}

export function calculateRegistrationMonthlyTotal(
  planCode: RegistrationPlanCode,
  professionalCount: number
): number {
  return planCode === MERCADO_PAGO_PLAN_CODE
    ? calculateProfessionalPlanMonthlyTotal(professionalCount)
    : 0;
}

export function formatCop(value: number): string {
  return `$${new Intl.NumberFormat('es-CO', {
    maximumFractionDigits: 0,
  }).format(Math.max(0, Math.round(value)))}`;
}
